import { render, staticRenderFns } from "./TabControl.vue?vue&type=template&id=ef315a2c&scoped=true&"
import script from "./TabControl.vue?vue&type=script&lang=js&"
export * from "./TabControl.vue?vue&type=script&lang=js&"
import style0 from "./TabControl.vue?vue&type=style&index=0&id=ef315a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef315a2c",
  null
  
)

export default component.exports